// extracted by mini-css-extract-plugin
export default {"documentList":"ListDocuments_documentList__eB2-O","documents":"ListDocuments_documents__L5RAA","document":"ListDocuments_document__4o+WL","title":"ListDocuments_title__YJ329"};